__turbopack_context__.v({
  "img": "style-module-scss-module__k04miq__img",
  "item": "style-module-scss-module__k04miq__item",
  "link": "style-module-scss-module__k04miq__link",
  "list": "style-module-scss-module__k04miq__list",
  "root": "style-module-scss-module__k04miq__root",
  "title": "style-module-scss-module__k04miq__title",
});
